import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TestLayer } from 'app/services/layer.service';

interface LayerItem extends TestLayer {
	isSelected?: boolean;
}

export interface TestLayerSelectInputData {
	layers: LayerItem[];
}

@Component({
  selector: 'app-test-layer-select',
  templateUrl: './test-layer-select.component.html',
  styleUrls: ['./test-layer-select.component.css']
})
export class TestLayerSelectComponent implements OnInit {

	layers: LayerItem[];
	constructor(
		@Inject(MAT_DIALOG_DATA) private data: TestLayerSelectInputData,
		private dialogRef: MatDialogRef<TestLayerSelectComponent>
	) { }

	cancel() {
		this.dialogRef.close();
	}
	restore() {
		const layerIds = this.layers.filter(l => l.isSelected).map(l => l.id);
		if (layerIds.length) {
			this.dialogRef.close({
				layerIds: layerIds
			});
		} else {
			this.dialogRef.close();
		}
	}
	ngOnInit() {
		this.layers = this.data.layers || [];
	}

}
